<template>
	<div id="dorm_right2">
		<div class="main-value leavelist">
			<div class="normal-header">请假学生名单</div>
			<dv-scroll-board :config="config" class="table" />
		</div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
var buildIds = storage.getItem("buildIds");
export default {
	data() {
		return {
			config: {}
		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，1小时
		let _this = this;
		this.interval = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60);
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	methods: {
		initData() {
			let _this = this;
			this.$http.get("/dataView/dorm/qjUsers?orgId=" + orgId + "&buildIds=" + buildIds).then(res => {
				if (res.data.code === 200) {
					var result = [];
					for (let i = 0; i < res.data.result.length; i++) {
						var record = res.data.result[i];
						var leaveStr = '';
						var day = parseInt(record.leaveDuration / (60 * 24));
						var hour = parseInt(record.leaveDuration / 60 % 24);
						var min = parseInt(record.leaveDuration % 60);
						if (day > 0) {
							leaveStr += day + '天';
						}
						if (hour > 0) {
							leaveStr += hour + '小时';
						}
						if (min > 0) {
							leaveStr += min + '分钟';
						}
						result.push([record.studentName, record.dormName, leaveStr]);
					}
					var config = {
						header: ['姓名', '宿舍号', '请假时长'],
						data: result,
						headerBGC: '',
						oddRowBGC: 'none',
						evenRowBGC: 'none',
						headerHeight: 40,
						rowNum: 5, //表格行数
						waitTime: 2000,
						columnWidth: [75, 135],
						align: ['left', 'center', 'right']
					};
					_this.config = config;
				}
			});
		}
	}
};
</script>

<style lang="scss">
#dorm_right2 {
	height: 100%;

	.leavelist {
		padding: 0.3rem 0.4rem
	}

	.leavelist .table {
		padding-top: 0.1rem;
		width: 100%;
		height: 90%;
	}

	.leavelist .header {
		background: url("../../assets/img/table_bg.png") center repeat-y;
		background-size: 150%;
		color: #00f0ff;
		font-size: 0.2rem;
		font-weight: bold;
	}

	.leavelist .row-item {
		background: url("../../assets/img/table_bg.png") bottom no-repeat;
		background-size: 160%;
		color: #00f0ff;
		font-size: 0.19rem;
	}

	.leavelist .row-item span {
		color: #e7d808
	}

	@media screen and (min-width: 768px) and (max-width: 992px) {}

	@media screen and (min-width: 1200px) and (max-width: 1920px) {}
}
</style>
